// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"rttlR","spinner":"Czo63"};